import { useEffect } from 'react';
import type { Filter, QueryOptions } from 'gossamer-unified';

export const useSetMaxWeekCommencing = (
  queryOptions: QueryOptions,
  setQueryOptions: (options: QueryOptions) => void,
) => {
  useEffect(() => {
    const now = new Date();
    now.setDate(now.getDate() - now.getDay() - 5);
    const maxWeekCommencing = now.toISOString().split('T')[0];
    const filters = queryOptions.where?.and?.slice() || [];
    const index = filters.findIndex((filter: Filter) => filter.fieldId === 'week_commencing');
    if (index > -1) {
      filters.splice(index, 1);
    }
    setQueryOptions({
      ...queryOptions,
      where: {
        ...queryOptions.where,
        and: [{ fieldId: 'week_commencing', operator: 'lt', value: maxWeekCommencing }, ...filters],
      },
    });
  }, []);
};
